var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { errorGraphics, logGraphics, warnGraphics } from "../logging/logging";
import { utilEnvironment } from "../utilEnvironment";
import { utilNumber } from "../utilNumber";
import { utilPoint } from "../utilPoint";
var UtilGrid = /** @class */ (function () {
    function UtilGrid() {
        var _this = this;
        this.setup = function (gridConfig) {
            _this.tileWidth = gridConfig.tileSizeX;
            _this.tileHeight = gridConfig.tileSizeY;
            _this.tileHalfWidth = gridConfig.tileSizeX / 2;
            _this.tileHalfHeight = gridConfig.tileSizeY / 2;
            _this.config = gridConfig;
        };
        this.getDimensions = function (obj) {
            var ax = _this.mapToScreenGlobal(obj.x, obj.y + obj.yExtent);
            var bx = _this.mapToScreenGlobal(obj.x + obj.xExtent, obj.y);
            var ay = _this.mapToScreenGlobal(obj.x, obj.y);
            var by = _this.mapToScreenGlobal(obj.x - obj.xExtent, obj.y - obj.yExtent);
            return {
                height: (by.y - ay.y) * 0.9,
                width: (bx.x - ax.x) * 0.5,
            };
        };
        this.getBaseDimensions = function (baseSetup) {
            var pos1 = _this.expansionIdToXY(39, baseSetup);
            var pos2 = _this.expansionIdToXY(41, baseSetup);
            var pos3 = _this.expansionIdToXY(46, baseSetup);
            var pos4 = _this.expansionIdToXY(48, baseSetup);
            var top = _this.mapToScreenGlobal(pos4.x + baseSetup.expansionsSizeX, pos4.y + baseSetup.expansionsSizeY);
            var left = _this.mapToScreenGlobal(pos3.x, pos3.y + baseSetup.expansionsSizeY);
            var right = _this.mapToScreenGlobal(pos2.x + baseSetup.expansionsSizeX, pos2.y);
            var bottom = _this.mapToScreenGlobal(pos1.x, pos1.y);
            return {
                bottom: bottom,
                left: left,
                right: right,
                top: top,
            };
        };
        this.mapToScreen = function (x, y) { return ({
            x: (x - y) * _this.tileHalfWidth,
            y: -(x + y) * _this.tileHalfHeight,
        }); };
        this.mapToScreenGlobal = function (x, y) { return ({
            x: (x - y) * _this.tileHalfWidth + _this.gridConfig.originBaseX,
            y: -(x + y) * _this.tileHalfHeight + _this.gridConfig.originBaseY,
        }); };
        this.screenToMap = function (x, y) { return ({
            x: Math.floor(-(y / _this.tileHeight - x / _this.tileWidth)),
            y: Math.floor(-(x / _this.tileWidth + y / _this.tileHeight)),
        }); };
        this.objectCenterOnScreen = function (object) {
            var p = _this.objectCenterOnMap(object);
            return _this.mapToScreen(p.x, p.y);
        };
        this.objectCenterOnScreenGlobal = function (object) {
            var p = _this.objectCenterOnMap(object);
            return _this.mapToScreenGlobal(p.x, p.y);
        };
        this.objectCenterRightOnScreen = function (object) {
            var p = _this.objectCenterRightOnMap(object);
            return _this.mapToScreen(p.x, p.y);
        };
        this.objectTopLeftOnScreenGlobal = function (object) {
            var p = _this.objectTopLeft0nMap(object);
            return _this.mapToScreenGlobal(p.x, p.y);
        };
        this.objectCenterOnScreenMinSquare = function (object) {
            var p = _this.objectCenterOnMapMinSquare(object);
            return _this.mapToScreen(p.x, p.y);
        };
        this.objectCenterOnScreenMinSquareGlobal = function (object) {
            var p = _this.objectCenterOnMapMinSquare(object);
            return _this.mapToScreenGlobal(p.x, p.y);
        };
        this.objectTopLeft0nMap = function (object) { return ({
            x: object.x,
            y: object.y + object.yExtent,
        }); };
        this.objectCenterOnMap = function (object) { return ({
            x: object.x + (object.xExtent + (object.volume || 0)) * 0.5,
            y: object.y + (object.yExtent + (object.volume || 0)) * 0.5,
        }); };
        this.objectHoverOnMap = function (object) { return ({
            x: (object.xExtent + (object.volume || 0)) * 0.5,
            y: (object.yExtent + (object.volume || 0)) * 0.5,
        }); };
        this.objectCenterRightOnMap = function (object) { return ({
            x: object.x + (object.xExtent + (object.volume || 0)) * 0.5,
            y: object.y + (object.volume || 0),
        }); };
        this.objectCenterOnMapMinSquare = function (object) {
            var halfMin = Math.min(object.xExtent, object.yExtent) * 0.5;
            return {
                x: object.x + halfMin,
                y: object.y + halfMin,
            };
        };
        this.expansionIdToXY = function (expansionId, baseSetup) {
            var x = expansionId % baseSetup.expansionsX;
            var y = Math.floor(expansionId / baseSetup.expansionsX);
            return {
                x: x * baseSetup.expansionsSizeX + baseSetup.startX,
                y: y * baseSetup.expansionsSizeY + baseSetup.startY,
            };
        };
        this.XYToExpansionId = function (x, y, baseSetup) {
            if (x < baseSetup.startX ||
                y < baseSetup.startY ||
                baseSetup.expansionsX * baseSetup.expansionsSizeX <= x - baseSetup.startX ||
                baseSetup.expansionsY * baseSetup.expansionsSizeY <= y - baseSetup.startY) {
                return -1;
            }
            var x1 = Math.floor((x - baseSetup.startX) / baseSetup.expansionsSizeX);
            var y1 = Math.floor((y - baseSetup.startY) / baseSetup.expansionsSizeY);
            return y1 * baseSetup.expansionsX + x1;
        };
        this.getExpansionPosition = function (expansionId, baseSetup) {
            var _a = _this.expansionIdToXY(expansionId, baseSetup), x = _a.x, y = _a.y;
            return _this.mapToScreen(x, y);
        };
        this.getExpansionNeighbours = function (expansionId, baseSetup) {
            var _a = _this.expansionIdToXY(expansionId, baseSetup), x = _a.x, y = _a.y;
            return [
                _this.XYToExpansionId(x + baseSetup.expansionsSizeX, y, baseSetup),
                _this.XYToExpansionId(x - baseSetup.expansionsSizeX, y, baseSetup),
                _this.XYToExpansionId(x, y + baseSetup.expansionsSizeY, baseSetup),
                _this.XYToExpansionId(x, y - baseSetup.expansionsSizeY, baseSetup),
            ].filter(function (id) { return _this.expansionExists(id, baseSetup); });
        };
        /**
         * Gets neighbours for the expansion and returns object with keys up, down, left, right.
         * Positions on map space:
         * Up = y+1
         * Down = y-1
         * Left = x-1
         * Right = x+1
         * @param expansionId
         * @param baseSetup
         */
        this.getExpansionNeighboursNamed = function (expansionId, baseSetup) {
            var _a = _this.expansionIdToXY(expansionId, baseSetup), x = _a.x, y = _a.y;
            var bottom = _this.XYToExpansionId(x, y - baseSetup.expansionsSizeY, baseSetup);
            var left = _this.XYToExpansionId(x - baseSetup.expansionsSizeX, y, baseSetup);
            var right = _this.XYToExpansionId(x + baseSetup.expansionsSizeX, y, baseSetup);
            var top = _this.XYToExpansionId(x, y + baseSetup.expansionsSizeY, baseSetup);
            return {
                down: _this.expansionExists(bottom, baseSetup) ? bottom : undefined,
                left: _this.expansionExists(left, baseSetup) ? left : undefined,
                right: _this.expansionExists(right, baseSetup) ? right : undefined,
                up: _this.expansionExists(top, baseSetup) ? top : undefined,
            };
        };
        this.clampToGridImpure = function (object, previousPos, baseSetup, unlockedExpansionIds) {
            var clamped = _this.clampToGrid(object, previousPos, baseSetup, unlockedExpansionIds);
            object.x = clamped.x;
            object.y = clamped.y;
            return object;
        };
        this.clampToGrid = function (object, previousPos, baseSetup, unlockedExpansionIds) {
            var obj = __assign({}, object);
            obj.x = utilNumber.clamp(obj.x, baseSetup.startX, baseSetup.startX + baseSetup.expansionsX * baseSetup.expansionsSizeX);
            obj.y = utilNumber.clamp(obj.y, baseSetup.startY, baseSetup.startY + baseSetup.expansionsY * baseSetup.expansionsSizeY);
            if (!_this.fitsInGrid(obj, baseSetup, unlockedExpansionIds)) {
                if (_this.fitsInGrid(__assign({}, obj, { x: previousPos.x }), baseSetup, unlockedExpansionIds)) {
                    obj.x = previousPos.x;
                }
                else if (_this.fitsInGrid(__assign({}, obj, { y: previousPos.y }), baseSetup, unlockedExpansionIds)) {
                    obj.y = previousPos.y;
                }
                else {
                    obj.x = previousPos.x;
                    obj.y = previousPos.y;
                }
            }
            return obj;
        };
        this.fitsInGrid = function (object, baseSetup, unlockedExpansionIds) {
            if (object.x < baseSetup.startX ||
                object.y < baseSetup.startY ||
                object.xExtent < 1 ||
                object.yExtent < 1 ||
                object.x + object.xExtent >
                    baseSetup.startX + baseSetup.expansionsX * baseSetup.expansionsSizeX ||
                object.y + object.yExtent >
                    baseSetup.startY + baseSetup.expansionsY * baseSetup.expansionsSizeY) {
                return false;
            }
            if (unlockedExpansionIds.indexOf(_this.XYToExpansionId(object.x, object.y, baseSetup)) ===
                -1 ||
                unlockedExpansionIds.indexOf(_this.XYToExpansionId(object.x + object.xExtent - 1, object.y, baseSetup)) === -1 ||
                unlockedExpansionIds.indexOf(_this.XYToExpansionId(object.x, object.y + object.yExtent - 1, baseSetup)) === -1 ||
                unlockedExpansionIds.indexOf(_this.XYToExpansionId(object.x + object.xExtent - 1, object.y + object.yExtent - 1, baseSetup)) === -1) {
                return false;
            }
            return true;
        };
        this.objToTileIds = function (obj, baseSetup) {
            var ids = [];
            var sizeX = baseSetup.expansionsSizeX * baseSetup.expansionsX;
            for (var i = 0; i < obj.xExtent * obj.yExtent; i++) {
                var offsetX = i % obj.xExtent;
                var offsetY = Math.floor(i / obj.xExtent);
                ids.push(offsetX + obj.x + (obj.y + offsetY) * sizeX);
            }
            return ids;
        };
        this.objectsToTileIds = function (objects, baseSetup) {
            return objects.reduce(function (acc, obj) {
                _this.objToTileIds(obj, baseSetup).forEach(function (id) { return acc.add(id); });
                return acc;
            }, new Set());
        };
        this.isSpaceFree = function (object, occupiedTiles, baseSetup) {
            return !_this.objToTileIds(object, baseSetup).some(function (id) { return occupiedTiles.has(id); });
        };
        this.isInFront = function (a, b) {
            if (_this.isInLine(a, b)) {
                // if the items are in line, prioritize the one on the left.
                // this is arbitrary and either  left or right would be correct
                // since we are talking about overlapping buildings AKA: an incorrect
                // iso positioning.
                return a.y > b.y;
            }
            else if (_this.containsGridObject(a, b)) {
                // if A contains (even partially B) default to A, again: incorrect iso use case
                return true;
            }
            else if (_this.containsGridObject(b, a)) {
                // if B contains TOTALLY a (no overlap, no partial contain) default to be, incorrect iso
                // use case
                return false;
            }
            return a.x < b.x + b.xExtent && a.y < b.y + b.yExtent;
        };
        this.isInLine = function (a, b) {
            var isInLineLeft = a.x + a.xExtent === b.x && a.y === b.y + b.yExtent;
            var isInLineRight = b.x + b.xExtent === a.x && b.y === a.y + a.yExtent;
            return isInLineLeft || isInLineRight;
        };
        this.containsGridObject = function (a, b) {
            var checkUnidimensional = function (aStart, aEnd, bStart, bEnd) {
                var startTouchEnd = aStart === bEnd || bEnd === aStart;
                var startsInA = bStart < aEnd && bStart >= aStart;
                var endsInA = bEnd < aEnd && bEnd >= aStart;
                return !startTouchEnd && (startsInA || endsInA);
            };
            return (checkUnidimensional(a.x, a.x + a.xExtent, b.x, b.x + b.xExtent) &&
                checkUnidimensional(a.y, a.y + a.yExtent, b.y, b.y + b.yExtent));
        };
        this.objectsOverlap = function (a, b) {
            var aHMin = _this.mapToScreen(a.x, a.y + a.yExtent).x;
            var aHMax = _this.mapToScreen(a.x + a.xExtent, a.y).x;
            var bHMin = _this.mapToScreen(b.x, b.y + b.yExtent).x;
            var bHMax = _this.mapToScreen(b.x + b.xExtent, b.y).x;
            a.volume = a.volume || 0;
            b.volume = b.volume || 0;
            return (
            // test if x regions intersect.
            !(a.x >= b.x + b.xExtent + b.volume || b.x >= a.x + a.xExtent + a.volume) &&
                // test if y regions intersect.
                !(a.y >= b.y + b.yExtent + b.volume || b.y >= a.y + a.yExtent + a.volume) &&
                // test if h regions intersect.
                !(aHMin >= bHMax || bHMin >= aHMax));
        };
        this.generateGridObjectGraph = function (objects) {
            var graph = new Map();
            var referenceCountMap = new Map();
            for (var i = 0; i < objects.length; i++) {
                var obj = objects[i];
                var deps = [];
                for (var j = 0; j < objects.length; j++) {
                    if (i === j) {
                        continue;
                    }
                    if (_this.objectsOverlap(obj, objects[j]) && !_this.isInFront(obj, objects[j])) {
                        var id = objects[j].id;
                        // Store graph edge
                        deps.push(id);
                        // Increase reference count
                        var refCount = referenceCountMap.get(id) || 0;
                        referenceCountMap.set(id, refCount + 1);
                    }
                }
                graph.set(obj.id, deps);
            }
            return { graph: graph, referenceCountMap: referenceCountMap };
        };
        this.topologicalSort = function (objects) {
            var _a = _this.generateGridObjectGraph(objects), referenceCountMap = _a.referenceCountMap, graph = _a.graph;
            if (utilEnvironment.isDevelopment()) {
                var set = new Set(objects.map(function (value) { return value.id; }));
                if (set.size !== objects.length) {
                    errorGraphics("utilGrid -> topologicalSort: Duplicate ids in objects to sort");
                }
            }
            // Kahn's algorithm
            var startNodes = objects.filter(function (val) { return !referenceCountMap.get(val.id); });
            var sorted = [];
            var objectMap = objects.reduce(function (acc, val) {
                acc.set(val.id, val);
                return acc;
            }, new Map());
            while (startNodes.length > 0) {
                var node = startNodes.shift();
                sorted.push(node);
                var edges = graph.get(node.id);
                for (var _i = 0, edges_1 = edges; _i < edges_1.length; _i++) {
                    var edge = edges_1[_i];
                    var count = referenceCountMap.get(edge);
                    referenceCountMap.set(edge, count - 1);
                    if (count - 1 <= 0) {
                        startNodes.push(objectMap.get(edge));
                        objectMap.delete(edge);
                    }
                }
            }
            if (sorted.length !== objects.length) {
                warnGraphics("Couldn't correctly sort objects!", objects);
                // To have at least unsorted things appear
                var unsorted = Array.from(objectMap.values());
                sorted.push.apply(sorted, unsorted);
                logGraphics("Unsorted objects", unsorted);
            }
            return sorted;
        };
        this.getAutoPlacementPosition = function (size, baseSetup, unlockedExpansionIds, occupiedTiles) {
            var minSize = Math.min(size.x, size.y);
            var realGridSizeX = baseSetup.expansionsX * baseSetup.expansionsSizeX - baseSetup.startX;
            var realGridSizeY = baseSetup.expansionsY * baseSetup.expansionsSizeY - baseSetup.startY;
            var maxDistance = Math.max(realGridSizeX, realGridSizeY) - minSize;
            var gridObject = {
                id: -1,
                x: realGridSizeX,
                xExtent: size.x,
                y: realGridSizeY,
                yExtent: size.y,
            };
            var calcPos = function () {
                return _this.calculateFreePosition(gridObject, baseSetup, unlockedExpansionIds, size, occupiedTiles);
            };
            for (var cornerDistance = 0; cornerDistance <= maxDistance; cornerDistance++) {
                gridObject.x = realGridSizeX - cornerDistance - minSize + baseSetup.startX;
                gridObject.y = realGridSizeY - cornerDistance - minSize + baseSetup.startY;
                for (var edgeDistance = cornerDistance; edgeDistance >= 0; edgeDistance--) {
                    gridObject.y += edgeDistance;
                    var pos = calcPos();
                    if (pos == undefined) {
                        gridObject.y -= edgeDistance;
                        gridObject.x += edgeDistance;
                        pos = calcPos();
                        if (pos == undefined) {
                            gridObject.x -= edgeDistance;
                        }
                    }
                    if (pos !== undefined) {
                        return pos;
                    }
                }
            }
            return {
                flipped: false,
                x: baseSetup.expansionsX * baseSetup.expansionsSizeX - size.x + baseSetup.startX,
                y: baseSetup.expansionsY * baseSetup.expansionsSizeY - size.y + baseSetup.startY,
            };
        };
        this.calculateFreePosition = function (gridObject, baseSetup, unlockedExpansionIds, size, occupiedTiles) {
            // Return flipping of the building and try placement
            gridObject.xExtent = size.x;
            gridObject.yExtent = size.y;
            var reclamp = function () {
                return _this.clampToGrid(gridObject, { x: -1000, y: -1000 }, baseSetup, unlockedExpansionIds);
            };
            var clamped = reclamp();
            var flipped = false;
            var getPosition = function () {
                return _this.getFreePosition(baseSetup, gridObject, clamped, occupiedTiles, flipped);
            };
            var pos = getPosition();
            if (pos === undefined) {
                // Flip the building and try placement
                gridObject.xExtent = size.y;
                gridObject.yExtent = size.x;
                flipped = true;
                clamped = reclamp();
                pos = getPosition();
            }
            return pos;
        };
        this.getFreePosition = function (baseSetup, gridObject, clamped, occupiedTiles, flipped) {
            if (utilPoint.equals(gridObject, clamped)) {
                if (_this.isSpaceFree(gridObject, occupiedTiles, baseSetup)) {
                    return {
                        flipped: flipped,
                        x: gridObject.x,
                        y: gridObject.y,
                    };
                }
            }
            return undefined;
        };
        this.expansionExists = function (id, baseSetup) {
            return id >= 0 && id < baseSetup.expansionsX * baseSetup.expansionsY;
        };
    }
    Object.defineProperty(UtilGrid.prototype, "gridConfig", {
        get: function () {
            return this.config;
        },
        enumerable: true,
        configurable: true
    });
    return UtilGrid;
}());
export var utilGrid = new UtilGrid();



//////////////////
// WEBPACK FOOTER
// ./src/utils/grid/utilGrid.ts
// module id = 82
// module chunks = 3